import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import { experience } from '@jira/polaris__lib-analytics/src/ConstantsExperience.tsx';
import { createExperienceWithMetaType } from '@jira/polaris__lib-analytics/src/createJpdExperience.tsx';
import { fireCompoundAnalyticsEvent } from '@jira/polaris__lib-analytics/src/fireCompoundAnalyticsEvent.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

const fieldOptionUpdateExperience = createExperienceWithMetaType(
	experience.fieldsSidebar.fieldOptionUpdate,
	'renameOption',
	(err) => `FieldOptionUpdate: ${err?.message ?? 'generic error'}`,
);

export const renameOption =
	(fieldKey: FieldKey, jiraOptionId: string, newValue: string) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ onFieldUpdateFailed, projectId, createAnalyticsEvent, fieldRemote }: Props,
	): Promise<void> => {
		const state = getState();
		const previousOptions = state.fields[fieldKey].options;

		const newOptions = previousOptions?.map((option) => {
			if (option.jiraOptionId === jiraOptionId) {
				return {
					...option,
					value: newValue,
				};
			}
			return option;
		});

		const fields = {
			...state.fields,
			[fieldKey]: {
				...state.fields[fieldKey],
				options: newOptions,
			},
		};

		setState({ fields });

		if (projectId !== undefined) {
			fieldOptionUpdateExperience.start();

			fieldRemote
				.renameFieldOption({
					fieldKey,
					newTitle: newValue,
					optionId: +jiraOptionId,
				})
				.then(() => {
					fieldOptionUpdateExperience.success();

					fireCompoundAnalyticsEvent.FieldConfig.optionLabelChanged(createAnalyticsEvent({}), {
						issueFieldKey: fieldKey,
						issueFieldType: fields[fieldKey].type,
						fieldValueId: jiraOptionId,
					});
				})
				.catch((error: Error) => {
					fieldOptionUpdateExperience.failure(error);

					onFieldUpdateFailed(error);
				});
		}
	};
